import { createLocaleProvider as o, createCountryCodeProvider as r, createRegionCodeProvider as n } from "@ado/location-library";
import { createTranslation as t } from "@ado/translation-library";
function u() {
  let e = o().provideCurrent().getValue();
  return r().provideCountryCode() === "CA" && n().provideRegionCode() === "QC" && (e = "fr_CA"), t(e);
}
export {
  u as createTranslationsPlugin
};
//# sourceMappingURL=index.js.map
